module.exports = __webpack_public_path__ + "static/media/team2.5594ed07.png";